import { Inject, Injectable } from '@angular/core';
import { filter, map, Observable, of, switchMap, tap } from 'rxjs';

import { OktaInterfaceService } from '@shure/cloud/shared/okta/data-access';

import { CloudFeatureFlagsService, FEATURE_FLAG_SERVICE } from './cloud-feature-flags.service';

@Injectable({ providedIn: 'root' })
export class CloudFeatureFlagsInitializationService {
	private isInitialized = false;

	constructor(
		private readonly oktaIntfService: OktaInterfaceService,
		@Inject(FEATURE_FLAG_SERVICE) private readonly featureFlagsService: CloudFeatureFlagsService
	) {}

	public initialize$(setUserConfig: boolean): Observable<boolean> {
		if (this.isInitialized) {
			return of(true);
		}

		if (setUserConfig) {
			return this.oktaIntfService.getUserProfile$().pipe(
				filter((userProfile) => !!userProfile.userId),
				switchMap((userProfile) => {
					// setConfig internally waits for Statsig to finish loading
					return this.featureFlagsService.setConfig$({
						userID: userProfile.userId,
						email: userProfile.email,
						custom: {
							organizationId: userProfile.orgId,
							organizationName: userProfile.orgName,
							hostUrl: window.location.origin
						}
					});
				}),
				tap(() => {
					this.isInitialized = true;
				}),
				map(() => true)
			);
		}

		return this.featureFlagsService.isLoading$.pipe(
			filter((isLoading) => {
				return !isLoading;
			}),
			tap(() => {
				this.isInitialized = true;
			}),
			map(() => true)
		);
	}
}
